import $ from "jquery";
// JS
import './js/main.js'

// SCSS
import './assets/scss/main.scss'
// import 'bootstrap';
